// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","dashboard":"App_dashboard__EE79k","search":"App_search__+nw27"};